module.exports = __webpack_public_path__ + "img/icon_number_0@2x.6615c9da.png";